import LayoutRegisterPageComponent from 'src/components/user/layout-register-page-component';
import SchoolRegisterContainer from 'src/containers/user/school-register-container/school-register-container';

function SchoolRegisterPage() {
  return (
    <LayoutRegisterPageComponent>
      <SchoolRegisterContainer />
    </LayoutRegisterPageComponent>
  );
}

export default SchoolRegisterPage